import { JSX } from "react";

export const School = (): JSX.Element => {
    return (
        <svg
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 13.75L3.75 10.9V6.4L0.75 4.75L9 0.25L17.25 4.75V10.75H15.75V5.575L14.25 6.4V10.9L9 13.75ZM9 7.525L14.1375 4.75L9 1.975L3.8625 4.75L9 7.525ZM9 12.0438L12.75 10.0188V7.1875L9 9.25L5.25 7.1875V10.0188L9 12.0438Z"
                fill="#1D2D58"
            />
        </svg>
    );
};
